<template>
    <div
         :class="['table__head', allowTooltip ? 'is-action' : '']"
         v-resize="resizeHandler"
    >
        <div
                v-for="(title, i) in tableHead"
                :key="i"
                :class="['table__head-item', getAdaptiveMode(title, true)]"
                :style="{'flex-basis': title.width}"
        >
            {{ $t(`table.${title.name}`) }}
        </div>
        <div
                v-if="actualMode || isMapOpen"
                class="table__head-more"
        ></div>
    </div>
</template>

<script>
    import table from "@/mixins/table";

    export default {
        mixins: [table],

        props: {
            tableHead: {
                type: Array,
                required: true,
            },
            moreMode: {
                type: String,
                required: true,
            },
            isMapOpen: {
                type: Boolean,
                required: true,
            },
            allowTooltip: {
                type: Boolean,
                required: false,
            },
        },
    }
</script>

<style lang="sass" scoped>
.table
    &__head
        font-size: $font-size--xs
        +semi
        color: $color--dark-lighten
        display: flex
        justify-content: space-between
        padding: 18px 12px
        &.is-action
            .table__head-item
                &:last-of-type
                    text-align: center

        &-more
            width: 7px

        &-item
            flex: 1
            flex-basis: 70px

            &.is-tablet
                +r(1023)
                    display: none

            &.is-mobile
                +r(767)
                    display: none
</style>